module.exports = __webpack_public_path__ + "cf3f68c3c1bf253a2affac0925e542eb.jpg";